import React from 'react';
import PropTypes from 'prop-types';
import ReactAudioPlayer from 'react-audio-player';

class ButtonPlayer extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      play: false
    };

    this.playPause = this.playPause.bind(this);
  }

  playPause() {
    if (this.state.load || this.state.play) {
      this.setState({
        load: false,
        play: false
      });
    } else {
      this.setState({
        load: true
      });
    }
  }

  onPlay(e) {
    this.setState({
      play: true,
      load: false
    });
  }

  onEnded(e) {
    this.setState({
      play: false,
      load: false
    });
  }

  render() {
    return (
      <div>
        { (this.state.load || this.state.play) && (
          <ReactAudioPlayer
            src={`/api/v1/vocalize?text=${encodeURIComponent(this.props.text)}`}
            controls={false}
            autoPlay
            onPlay={(e) => this.onPlay(e)}
            onEnded={(e) => this.onEnded(e)}
          />
        ) }
        <div onClick={this.playPause} className="bg-white text-black text-sm px-2 py-1 font-semibold shadow border border-grey-light inline-block rounded-full transition duration-100 ease-in-out hover:shadow-lg cursor-pointer">
          { this.state.load ? (
            <div>
              <i className="fas fa-spinner-third fa-spin"></i> Chargement
            </div>
          ) : (
            <div>
              { this.state.play ? (
                <div>
                  🔊 Lecture en cours...
                </div>
              ) : (
                <div>
                  🔉 {this.props.children && this.props.children}
                </div>
              ) }
            </div>
          )}
        </div>
      </div>
    );
  }
}

ButtonPlayer.propTypes = {
  text: PropTypes.string.isRequired
};

ButtonPlayer.defaultProps = {};

export default ButtonPlayer;
